import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { AuthComponent } from "./views/auth/auth.component";
import { PasswordResetComponent } from "./views/auth/password-reset/password-reset.component";
import { RestorePasswordComponent } from "./views/auth/restore-password/restore-password.component";
import { SignUpComponent } from "./views/auth/sign-up/sign-up.component";
import { VerifyEmailComponent } from "./views/auth/verify-email/verify-email.component";
import { DashboardComponent } from "./views/in-app/dashboard/dashboard.component";
import { FaxComponent } from "./views/in-app/faxes/fax/fax.component";
import { FaxesComponent } from "./views/in-app/faxes/faxes.component";
import { SendComponent } from "./views/in-app/faxes/send/send.component";
import { InAppComponent } from "./views/in-app/in-app.component";
import { PhoneBookComponent } from "./views/in-app/phone-book/phone-book.component";
import { FiltersComponent } from "./views/in-app/settings/filters/filters.component";
import { NotificationsComponent } from "./views/in-app/settings/notifications/notifications.component";
import { PasswordComponent } from "./views/in-app/settings/password/password.component";
import { ProfileComponent } from "./views/in-app/settings/profile/profile.component";
import { SettingsComponent } from "./views/in-app/settings/settings.component";
import { UsageSummaryComponent } from "./views/in-app/settings/usage-summary/usage-summary.component";
import { SubscriptionComponent } from "./views/in-app/subscription/subscription.component";
import { LegalComponent } from "./views/legal/legal.component";
import { NotFoundComponent } from "./views/not-found/not-found.component";
import { PrivacyComponent } from "./views/privacy/privacy.component";
import { GuidesComponent } from "./views/resources/guides/guides.component";
import { ResourcesComponent } from "./views/resources/resources.component";

const routes: Routes = [
  {
    path: "auth",
    component: AuthComponent,
  },
  {
    path: "auth/sign-up",
    component: SignUpComponent,
  },
  {
    path: "auth/restore-password",
    component: RestorePasswordComponent,
  },
  {
    path: "auth/verify-email",
    component: VerifyEmailComponent,
  },
  {
    path: "email-confirm",
    component: VerifyEmailComponent,
  },
  {
    path: "password-reset",
    component: PasswordResetComponent,
  },
  {
    path: "",
    component: InAppComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "",
        component: DashboardComponent,
      },
      {
        path: "faxes",
        children: [
          {
            path: "",
            component: FaxesComponent,
          },
          {
            path: "send",
            component: SendComponent,
          },
          {
            path: ":id",
            component: FaxComponent,
          },
        ],
      },
      {
        path: "settings",
        component: SettingsComponent,
        children: [
          {
            path: "",
            pathMatch: "full",
            redirectTo: "profile",
          },
          {
            path: "profile",
            component: ProfileComponent,
          },
          {
            path: "filters",
            component: FiltersComponent,
          },
          {
            path: "password",
            component: PasswordComponent,
          },
          {
            path: "notifications",
            component: NotificationsComponent,
          },
          {
            path: "usage-summary",
            component: UsageSummaryComponent,
          },
        ],
      },
      {
        path: "subscription",
        component: SubscriptionComponent,
      },
      {
        path: "phone-book",
        component: PhoneBookComponent,
      },
    ],
  },
  {
    path: "privacy",
    component: PrivacyComponent,
  },
  {
    path: "resources",
    component: ResourcesComponent,
    children: [
      {
        path: "guides",
        component: GuidesComponent,
      },
    ],
  },
  {
    path: "legal",
    component: LegalComponent,
  },
  {
    path: "**",
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: "enabledBlocking",
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
